<script>
    import { onMount } from 'svelte';
    import AddonModal from '../AddonModal.svelte';
    import ChannelsModal from '../ChannelsModal.svelte';
    import AddressModal from '../common/AddressModal.svelte';
    import Preloader from '../Preloader.svelte';
    import { store, store_offer } from '../../Store.svelte';
    import OfferMain from './OfferMain.svelte';
    import { CONSTANTS } from '../comparator/utils/constant';

    export let toggleEditAddress = () => {};

    let isOffnet = $store.requestedAddress.offnetCoverage;
    let checkedVix =
        $store.requestedServices.isVix != undefined
            ? $store.requestedServices.isVix
            : false;
    let checkedNetflix =
        $store.requestedServices.isNetflix != undefined
            ? $store.requestedServices.isNetflix
            : false;
    let checkedHBO =
        $store.requestedServices.isHBO != undefined
            ? $store.requestedServices.isHBO
            : false;
    let checkedCombos =
        $store.requestedServices.isCombo != undefined
            ? $store.requestedServices.isCombo
            : false;
    let tripleplay_modular_combos = [];
    let residencial_modular_combos = [];
    let tv_modular = [];
    let izzimovil_modular = [];
    let offnet_izzi = [];
    let offnet_movil = [];
    let render = 0;

    let selected = isOffnet ? 'tv_izzi_offnet' : '4p';
    let selectedMovilTerm = 'with-forced-term';
    let selectedMovilMobileData = '5-gb-plan';
    $store.requestedServices.isSky = false;

    let displayedPlans = { plans: [], category: '' };
    $: selected, setDisplayedPlans(selected);

    function setDisplayedPlans(selected) {
        displayedPlans = getOfferBySelectedPlan(selected);
    }

    function getOfferBySelectedPlan(selected) {
        if (!$store_offer.loadedOffer.offers) {
            return {
                plans: [],
                category: '',
            };
        }

        $store.requestedServices.isSky = selected === 'sky';
        if (!['3p', '2p'].includes(selected)) {
            checkedCombos = false;
            $store.requestedServices.isCombo = checkedCombos;
        }
        switch (selected) {
            case '4p':
                return {
                    plans:
                        $store_offer.loadedOffer.offers.tripleplay_modular ??
                        [],
                    category: CONSTANTS.CATEGORY_4PLAY,
                };
            case '3pm':
                return {
                    plans: residencial_modular_combos ?? [],
                    category: CONSTANTS.CATEGORY_TRIPLEPLAY_MOVIL,
                };
            case 'tab_tripleplay':
                return {
                    plans: [],
                    category: '',
                };
            case '2p':
                return {
                    plans: residencial_modular_combos,
                    category: CONSTANTS.CATEGORY_RESIDENCIAL,
                };
            case '3p':
                return {
                    plans: checkedCombos
                        ? tripleplay_modular_combos
                        : $store_offer.loadedOffer.offers.tripleplay_modular ??
                          [],
                    category: CONSTANTS.CATEGORY_TRIPLEPLAY,
                };
            case 'tv':
                return {
                    plans: tv_modular,
                    category: CONSTANTS.CATEGORY_TV,
                };
            case 'movil':
                return {
                    plans: izzimovil_modular,
                    category: CONSTANTS.CATEGORY_MOVIL,
                };
            case 'tv_izzi_offnet':
                return {
                    plans: offnet_izzi,
                    category: CONSTANTS.CATEGORY_TV,
                };
            case 'movil_offnet':
                return {
                    plans: offnet_movil,
                    category: CONSTANTS.CATEGORY_MOVIL,
                };
            case 'sky':
                return {
                    plans: $store_offer.loadedOffer.offers.offnet_sky,
                    category: CONSTANTS.CATEGORY_SKY,
                };
            default:
                return {
                    plans: [],
                    category: '',
                };
        }
    }

    const processOfferItems = (
        items,
        combos,
        applyDiscount = false,
        duplicatedItem = true
    ) => {
        items.forEach((item) => {
            if (item.vel === 80 || (item.vel === 100 && !duplicatedItem)) {
                combos.push({ ...item, isNetflix: true });
            } else {
                combos.push({ ...item, isNetflix: true });
            }
            if (duplicatedItem) {
                if (item.vel === 80 || item.vel === 100) {
                    if (applyDiscount) {
                        let cost = parseInt(item.cost).toString();
                        let promoCost = (
                            parseInt(item.promoCost) - 30
                        ).toString();
                        combos.push({
                            ...item,
                            cost: cost,
                            promoCost: promoCost,
                            isNetflix: false,
                            isHBO: true,
                        });
                    } else {
                        combos.push({ ...item, isNetflix: true });
                    }
                }
            }
        });
    };

    const loadData = () => {
        const { loadedOffer } = $store_offer;
        const { offers } = loadedOffer;

        if (offers.tripleplay_modular) {
            processOfferItems(
                offers.tripleplay_modular,
                tripleplay_modular_combos,
                true
            );
        }
        if (offers.residencial_modular) {
            processOfferItems(
                offers.residencial_modular,
                residencial_modular_combos,
                false,
                false
            );
        }

        tv_modular = offers.tv_modular || offers.offnet;
        izzimovil_modular = offers.izzimovil_modular;
        offnet_izzi = offers.offnet_izzi;
        offnet_movil = offers.offnet_izzi_movil;
        setDisplayedPlans(selected);
    };

    $: if ($store_offer.loadedOffer.offers) {
        render += 1;
        if (render <= 1) {
            loadData();
        }
    }

    function onSelectionChange(event) {
        const selectedPlan = mapSelectionToPlan(event);
        onChangePlay({ detail: selectedPlan });
    }

    function mapSelectionToPlan(event) {
        const selectedServices = event.detail;

        const internetSelected = selectedServices.includes('internet');
        const tvSelected = selectedServices.includes('tv');
        const movilSelected = selectedServices.includes('movil');
        const isSky = selectedServices.includes('sky');

        const isOffnet = $store.requestedAddress.offnetCoverage;
        if (isOffnet) {
            if (isSky) {
                return 'sky';
            }

            if (tvSelected) {
                return 'tv_izzi_offnet';
            }
            if (movilSelected) {
                return 'movil_offnet';
            }

            return '';
        }

        if (internetSelected && tvSelected && movilSelected) {
            return '4p';
        }

        if (internetSelected && tvSelected) {
            return '3p';
        }

        if (internetSelected && movilSelected) {
            return '3pm';
        }

        if (tvSelected && movilSelected) {
            return '';
        }

        if (internetSelected) {
            return '2p';
        }

        if (tvSelected) {
            return 'tv';
        }

        if (movilSelected) {
            return 'movil';
        }

        return '';
    }

    function onChangePlay(event) {
        selected = event.detail;
        checkedVix = false;
        checkedNetflix = false;
        checkedHBO = false;
        if (selected === '3pplus') {
            checkedVix = true;
            $store.requestedServices.isVix = checkedVix;
        }
        if (selected === 'tv' || selected === 'movil') {
            checkedNetflix = false;
            checkedCombos = false;
            $store.requestedServices.isVix = checkedVix;
            $store.requestedServices.isCombo = checkedCombos;
        }
        validarStreaming();
    }

    function onChangeMovilTerm(event) {
        selectedMovilTerm = event.target.value;
        selectedMovilMobileData =
            selectedMovilTerm === 'without-forced-term'
                ? '8-gb-plan'
                : '5-gb-plan';
    }

    function onChangeMovilMobileData(event) {
        selectedMovilMobileData = event.target.value;
    }

    function onChangeCheckedCombos(checked) {
        checkedCombos = checked;
        $store.requestedServices.isVix = checked;
        $store.requestedServices.isCombo = checked;
        setDisplayedPlans(selected);
    }

    function validarStreaming() {
        $store.requestedServices.isVix = $store.requestedServices.isCombo;
        if (
            (checkedNetflix && !$store.requestedServices.isNetflix) ||
            (checkedHBO && !$store.requestedServices.isHBO)
        ) {
            checkedVix = true;
            $store.requestedServices.isVix = checkedVix;
        }
        $store.requestedServices.isNetflix = checkedNetflix;
        $store.requestedServices.isHBO = checkedHBO;
    }

    onMount(() => {
        $store.requestedServices.isVix = false;
        try {
            window.document.dispatchEvent(
                new Event('DOMContentLoaded', {
                    bubbles: true,
                    cancelable: true,
                })
            );
        } catch (err) {}
    });
    function popupClick() {}
</script>

<main>
    {#if $store_offer.loadedOffer == null || $store_offer.loadedOffer.offers == null}
        <div class="pure-g full-width">
            <div class="pure-u-1">
                <div class="text-center">
                    <h2 class="text-fs-23 fw-semibold base-text m-b-5">
                        Obteniendo paquetes disponibles
                    </h2>
                    <p class="text-fs-13 m-b-15">
                        {$store.requestedAddress.addressString}
                        {$store.requestedAddress.postalCode}
                    </p>
                    <p class="text-fs-13">
                        <a
                            href="#/"
                            on:click|preventDefault={popupClick}
                            class="popup base-text underline"
                            data-custom-open="modal-cobertura"
                            >Cambiar dirección</a
                        >
                    </p>
                </div>
                <div class="pure-g">
                    <div class="pure-u-1">
                        <div class="text-center"><Preloader /></div>
                    </div>
                </div>
            </div>
        </div>
    {:else}
        <script>
            setTimeout(function () {
                try {
                    window.document.dispatchEvent(
                        new Event('DOMContentLoaded', {
                            bubbles: true,
                            cancelable: true,
                        })
                    );
                } catch (err) {}
            }, 1500);
        </script>
        <div class="pure-g full-width">
            <div class="pure-u-1">
                <OfferMain
                    plansObject={displayedPlans}
                    {onSelectionChange}
                    {toggleEditAddress}
                    {onChangeMovilMobileData}
                    {selectedMovilMobileData}
                    {onChangeMovilTerm}
                    {selectedMovilTerm}
                    {onChangeCheckedCombos}
                    {checkedCombos}
                    {isOffnet}
                />
            </div>
        </div>
    {/if}

    <AddonModal />
    <ChannelsModal />

    <div>
        <div class="modal" id="modal-cobertura" aria-hidden="true">
            <AddressModal locationPath="residencial" />
        </div>
    </div>
</main>
